import React from 'react';

//Estilos
import './Footer.css';

function Footer() {
    return (
        <div className="footer-container">
            <p>INAVI®</p>
        </div>
    );
}

export default Footer;
